export const deleteAllProductsFromCartMutation = /* GraphQL */ `
    mutation deleteAllProductsFromCart($cart_id: String!) {
        deleteAllProductsFromCart(input: { cart_id: $cart_id }) {
            status
        }
    }
`
